export default "__VITE_ASSET__CVYfKK0N__"